import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

export interface IDepartmentEmployee {
  id: string;
  name: string;
  email: string;
  role: "employee" | "departmentAdmin";
}

export interface IDepartmentAdmin {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  role: "departmentAdmin";
}

export interface Department {
  _id: string;
  name: string;
  description?: string;
  companyId: string;
  departmentAdmin?: IDepartmentAdmin;
  employees: IDepartmentEmployee[];
  coursesAssignedToDepartment: string[];
  createdAt: string;
  isActive: boolean;
}

export const useDepartments = (companyId: string) => {
  return useQuery({
    queryKey: ["departments", companyId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<{ data: Department[] }>(
        `/api/v1/departments?company=${companyId}`
      );
      return data.data;
    },
    enabled: !!companyId,
  });
};

